// MediaFormModal.js
import React, { useState } from 'react';
import axios from 'axios';

const MediaFormModal = ({ onClose }) => {
  const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
  const userId = userData?.user_id || null;
  const [telegramId, setTelegramId] = useState('');
  const [twitterId, setTwitterId] = useState('');
  const [telegramScreenshot, setTelegramScreenshot] = useState(null);
  const [twitterScreenshot, setTwitterScreenshot] = useState(null);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!telegramScreenshot || !twitterScreenshot) {
      setMessage('Please upload both screenshots.');
      return;
    }

    const formData = new FormData();
    formData.append('user_id', userId);
    formData.append('telegram_channel_id', telegramId);
    formData.append('twitter_channel_id', twitterId);
    formData.append('telegram_screenshot', telegramScreenshot);
    formData.append('twitter_screenshot', twitterScreenshot);

    try {
      const response = await axios.post('https://crowdwisdom.live/wp-json/api/v1/save-media-data', formData);
      if (response.data.success) {
        setMessage('Submission successful!');
      } else {
        setMessage('Submission failed. Please try again.');
      }
    } catch (error) {
      console.error(error);
      setMessage('Error submitting form.');
    }
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  };

  const modalStyle = {
    maxWidth:  window.innerWidth < 480 ? '350px' : '450px',
    width: '100%',
    backgroundColor: '#fff',
    padding:  window.innerWidth < 480? '20px' :'25px',
    borderRadius: '15px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    position: 'relative',
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '15px',
    fontSize:  window.innerWidth < 480? '18px':'18px',
    color:'#555',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '6px',
    fontSize: '14px',
    color: '#555',
    fontWeight: 'bold',
  };

  const inputStyle = {
    width: '100%',
    padding: '8px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    background: 'white',
    color: 'black',
    marginBottom:  window.innerWidth < 480?'15px':'17px',
    boxSizing: 'border-box',
  };

  const fileInputStyle = {
    ...inputStyle,
    padding: '8px',
  };

  const buttonStyle = {
    width: '100%',
    padding: '10px',
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#1877F2',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
  };

  const messageStyle = {
    marginTop: '15px',
    textAlign: 'center',
    fontSize: '14px',
    color: message.includes('success') ? 'green' : 'red',
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <button style={closeButtonStyle} onClick={onClose}>✖</button>
        <h4 style={{ textAlign: 'center', marginBottom: '25px' ,fontWeight:'bold',fontSize: window.innerWidth < 480?'16px':'18px'}}>Submit Social Media Proof</h4>
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <label style={labelStyle}>Telegram Channel ID</label>
          <input
            type="text"
            value={telegramId}
            onChange={(e) => setTelegramId(e.target.value)}
            required
            style={inputStyle}
          />

          <label style={labelStyle}>Twitter Channel ID</label>
          <input
            type="text"
            value={twitterId}
            onChange={(e) => setTwitterId(e.target.value)}
            required
            style={inputStyle}
          />

          <label style={labelStyle}>Telegram Join Screenshot</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setTelegramScreenshot(e.target.files[0])}
            required
            style={fileInputStyle}
          />

          <label style={labelStyle}>Twitter Join Screenshot</label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setTwitterScreenshot(e.target.files[0])}
            required
            style={fileInputStyle}
          />

          <button type="submit" style={buttonStyle}>Submit</button>
          {message && <p style={messageStyle}>{message}</p>}
        </form>
      </div>
    </div>
  );
};

export default MediaFormModal;
